import { z } from 'zod';
// New format ecosystem node
export const EcosystemNodeSchema = z.object({
    type: z.string(),
    value: z.string()
});
// New format: { domain, relationship, nodes }
export const NewEcosystemRecordSchema = z.object({
    domain: z.string(),
    relationship: z.string(),
    nodes: z.array(EcosystemNodeSchema)
});
// Legacy format: { domain, relatedNode, relatedNodeType }
export const LegacyEcosystemRecordSchema = z.object({
    domain: z.string(),
    relatedNode: z.string(),
    relatedNodeType: z.string()
});
// Union of both formats for backward compatibility
export const EcosystemRecordSchema = z.union([
    NewEcosystemRecordSchema,
    LegacyEcosystemRecordSchema
]);
export const EcosystemSchema = z.array(EcosystemRecordSchema).meta({
    id: 'Ecosystem'
});

//# sourceMappingURL=ecosystem.schema.js.map